const imprint = {
  title: 'Impressum',
  intro:
    'gut geregelt ist ein Schweizer Softwarehersteller und gehört zur Betascale-Gruppe.',
  headquarter: 'Hauptquartier',
};

export default imprint;
